import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

export default function PrivateRoute() {
  const { user, loading } = useContext(AuthContext);
  const { pathname } = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (window.location.hostname === "customers.titan4.it" && pathname === "/") {
    return <Navigate to="/register" replace={true} />;
  }

  return user ? <Outlet /> : <Navigate to="/login" />;
}
